var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('img',{attrs:{"src":require('../../assets/images/loading.svg'),"alt":"loading icon"}}),_vm._v(" "),_c('p',[_vm._v("Finding Artworks")])])}
var staticRenderFns = []

export { render, staticRenderFns }